import { createStyles } from 'antd-style';

export const useGoogleMapAdapterStyles = createStyles(() => ({
  mapContainer: {
    width: '100%',
    height: '100%',
  },
}));
